<template>
  <div
    class="change-report-visual row"
    v-if="teamEffectivenessReport && teamEffectivenessQuestionnaire"
  >
    <div class="col-sm-12">
      <HorizontalBarChart :data="changeData"></HorizontalBarChart>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import cms from "../../services/cms/cms";
import {
  CmsDocumentTypes,
  CmsTeamEffectivenessReview,
} from "../../services/cms/cms-type-definitions";
import cmsContentMap from "../../services/cms/cms-content-map";
import { TeamEffectivenessReviewApiModel } from "../../api-models";
import CharacterScopeColours from "../../styles/style-variables";

import HorizontalBarChart, {
  CategoryCountData,
  CategoryCountDataItem,
} from "./horizontal-bar-chart.vue";
import { getTeamEffectivenessReport } from "./get-team-effectiveness-report-team-id";

const props = defineProps<{
  reviewId: string | undefined;
}>();

const teamEffectivenessReport = ref<TeamEffectivenessReviewApiModel | null>(null);

const teamEffectivenessQuestionnaire = ref<CmsTeamEffectivenessReview | null>(null);

const changeData = computed<CategoryCountData>(() => {
  if (!teamEffectivenessReport.value || !teamEffectivenessQuestionnaire.value) {
    return [];
  }

  const questionIdsToText = teamEffectivenessQuestionnaire.value.data.body.reduce(
    (obj, question) => {
      obj[question.primary.question_id] = cms.asText(question.primary.question_title);
      return obj;
    },
    {},
  );

  const items = Object.keys(teamEffectivenessReport.value.aggregateRatings.changeCounts).map(
    (questionId) => {
      return {
        key: questionIdsToText[questionId],
        value: teamEffectivenessReport.value?.aggregateRatings.changeCounts[questionId],
        colour: CharacterScopeColours[questionId.toLowerCase()] || "black",
      } as CategoryCountDataItem;
    },
  );
  return items;
});

onMounted(() => {
  cms
    .getById(
      CmsDocumentTypes.CmsTeamEffectivenessReview,
      cmsContentMap.teamEffectiveness.questionnaireQuestions,
    )
    .then((d) => {
      teamEffectivenessQuestionnaire.value = d;
      getTeamEffectivenessReport(props.reviewId).then((data) => {
        teamEffectivenessReport.value = data;
      });
    });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "../../styles/bootstrap/variables.less";
</style>
